import React, { useEffect } from 'react';
import findIndex from 'lodash/findIndex';
import RsSlidablePaginatedNavigation from '@Pages/RetroSynthesis/components/RsSlidablePaginated/RsSlidablePaginatedNavigation';
import PropTypes from 'prop-types';

/* eslint-disable no-shadow */
/* eslint-disable react-hooks/exhaustive-deps */
function RsSlidablePaginatedNavigationWithDynamicItem({
  containerElement,
  contentElement,
  contentOffset,
  applyContentOffset,
  prevDisabled,
  nextDisabled,
  itemsElements,
  visibleItemIndex,
  isLoading,
}) {
  // index of the current most left item that is still within container
  const getCurrentIndex = () => {
    return findIndex(
      itemsElements,
      (item) => item.getBoundingClientRect().left + item.getBoundingClientRect().width - containerElement.getBoundingClientRect().left >= 0
    );
  };

  const goToIndex = (index) => {
    const itemAtIndex = itemsElements[index];
    if (itemAtIndex) {
      applyContentOffset(itemAtIndex.offsetLeft);
    }
  };

  // make item with visibleItemIndex visible
  useEffect(() => {
    const visibleItem = itemsElements[visibleItemIndex]; // item to make visible

    if (!visibleItem) {
      return;
    }

    const containerWidth = containerElement.offsetWidth;
    const visibleItemOffset = visibleItem.offsetLeft;

    if (visibleItemOffset + contentOffset < 0 || visibleItemOffset + contentOffset >= containerWidth) {
      const itemAtIndex = itemsElements[visibleItemIndex];
      if (contentElement.getBoundingClientRect().width - itemAtIndex.offsetLeft < containerElement.getBoundingClientRect().width) {
        // scroll right only to the right side of content to prevent empty space between last item and scroll controls
        applyContentOffset(contentElement.getBoundingClientRect().width - containerElement.getBoundingClientRect().width);
      } else {
        goToIndex(visibleItemIndex);
      }
    }
  }, [visibleItemIndex]);

  const goPrev = () => {
    const prevIndex = Math.max(getCurrentIndex() - 1, 0);
    goToIndex(prevIndex);
  };

  const goNext = () => {
    const nextIndex = Math.min(getCurrentIndex() + 1, itemsElements.length - 1);
    goToIndex(nextIndex);
  };

  return (
    <RsSlidablePaginatedNavigation
      prevDisabled={prevDisabled}
      nextDisabled={nextDisabled}
      goPrev={goPrev}
      goNext={goNext}
      isLoading={isLoading}
    />
  );
}

RsSlidablePaginatedNavigationWithDynamicItem.propTypes = {
  prevDisabled: PropTypes.bool,
  nextDisabled: PropTypes.bool,
  isLoading: PropTypes.bool,
  containerElement: PropTypes.object,
  contentElement: PropTypes.object,
  contentOffset: PropTypes.number,
  applyContentOffset: PropTypes.func,
  itemsElements: PropTypes.array,
  visibleItemIndex: PropTypes.number,
};

export default RsSlidablePaginatedNavigationWithDynamicItem;
